"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sport = void 0;
const flatbuffers = require("flatbuffers");
const match_status_js_1 = require("../../sportsbook/tree/match-status.js");
const sb_type_js_1 = require("../../sportsbook/tree/sb-type.js");
class Sport {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSport(bb, obj) {
        return (obj || new Sport()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSport(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Sport()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    sbId() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    customId() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    state() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    weight() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 0;
    }
    sportEventsNumber() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    liveSportEventsNumber() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    sbType() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : sb_type_js_1.SbType.sport;
    }
    matchStatuses(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? (obj || new match_status_js_1.MatchStatus()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    matchStatusesLength() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startSport(builder) {
        builder.startObject(9);
    }
    static addSbId(builder, sbId) {
        builder.addFieldInt32(0, sbId, 0);
    }
    static addCustomId(builder, customId) {
        builder.addFieldInt32(1, customId, 0);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(2, nameOffset, 0);
    }
    static addState(builder, state) {
        builder.addFieldInt8(3, state, 1);
    }
    static addWeight(builder, weight) {
        builder.addFieldInt8(4, weight, 0);
    }
    static addSportEventsNumber(builder, sportEventsNumber) {
        builder.addFieldInt16(5, sportEventsNumber, 0);
    }
    static addLiveSportEventsNumber(builder, liveSportEventsNumber) {
        builder.addFieldInt16(6, liveSportEventsNumber, 0);
    }
    static addSbType(builder, sbType) {
        builder.addFieldInt8(7, sbType, sb_type_js_1.SbType.sport);
    }
    static addMatchStatuses(builder, matchStatusesOffset) {
        builder.addFieldOffset(8, matchStatusesOffset, 0);
    }
    static createMatchStatusesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startMatchStatusesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endSport(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSport(builder, sbId, customId, nameOffset, state, weight, sportEventsNumber, liveSportEventsNumber, sbType, matchStatusesOffset) {
        Sport.startSport(builder);
        Sport.addSbId(builder, sbId);
        Sport.addCustomId(builder, customId);
        Sport.addName(builder, nameOffset);
        Sport.addState(builder, state);
        Sport.addWeight(builder, weight);
        Sport.addSportEventsNumber(builder, sportEventsNumber);
        Sport.addLiveSportEventsNumber(builder, liveSportEventsNumber);
        Sport.addSbType(builder, sbType);
        Sport.addMatchStatuses(builder, matchStatusesOffset);
        return Sport.endSport(builder);
    }
}
exports.Sport = Sport;
